module.exports = __webpack_public_path__ + "assets/img/99da2d3d961dc498f405e65856d44510.svg";